import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Button, Icon, MenuList, MenuItem,
  Dialog, DialogActions, DialogContent, DialogTitle,
  Typography, Accordion, AccordionSummary, AccordionDetails,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Pagination from '@material-ui/lab/Pagination';
import _ from 'lodash';
import apiService from '../../services.js/apiService';
import SortableCard from './sortableCard';
import OverLoading from '../../components/global/OverLoading';
import SearchCard from './searchCard';
import SearchBar from './searchBar';
import { Trim } from '../../common/util';
import { PositionType } from '../../common/constants';
import { IsEmpty } from '../../common/checks';

const CategoryPinnedPostList = (props) => {
  const [categoryGroup, setCategoryGroup] = useState();
  const [category, setCategory] = useState();
  const [existingPinnedPost, setExistingPinnedPost] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [postBrandSearch, setPostBrandSearch] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [openAdd, setOpenAdd] = useState(false);
  const [posts, setPosts] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [allPostCount, setAllPostCount] = useState(0);
  const [pageSize] = useState(20);

  const SortableCardRef = useRef();

  const fetchApi = async (selectedCategoryGroup) => {
    try {
      const data = await apiService.getCategoryPinnedPost(selectedCategoryGroup);
      setExistingPinnedPost(data);
      SortableCardRef.current.updateItems(data);

      return data;
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  const updateSeq = async (data) => {
    try {
      setLoading(true);
      const res = await apiService.updateCategoryPinnedPostOrderPosition(data.categoryGroup, data.postIds);
      if (res) {
        toast.success('Position updated');

        fetchApi(data.categoryGroup);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  const onSortableCardEvent = async (eventData) => {
    const newOrdering = eventData.data.new.map((v) => v.postId);
    const pinnedPosts = { categoryGroup, postIds: newOrdering };
    updateSeq(pinnedPosts);
  };

  const onDeletePinnedPost = async (postId) => {
    try {
      setLoading(true);
      const res = await apiService.removeCategoryPinnedPostPositionType(categoryGroup, postId);
      if (res) {
        toast.success('Post removed');

        fetchApi(categoryGroup);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  const onUpdatePosType = async (post) => {
    try {
      setLoading(true);
      const res = await apiService.updateCategoryPinnedPostPositionType(categoryGroup, post.postId, post.positionType);
      if (res) {
        toast.success('Position type updated');

        fetchApi(categoryGroup);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  useEffect(() => {
    setCategoryGroup(props.match.params.categoryGroup);
    setCategory(props.match.params.category);
  }, [props.match.params]);

  useEffect(() => {
    if (!IsEmpty(categoryGroup)) {
      fetchApi(categoryGroup);
    }
  }, [categoryGroup]);

  const onClickAdd = () => {
    setRefresh(true);
    setPostBrandSearch(null);
    setPageNo(1);
    setOpenAdd(true);
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
    setRefresh(true);
  };

  useEffect(() => {
    if (refresh) {
      fetchApi(categoryGroup);
    }
  }, [refresh]);

  const onAddPinnedPost = async (data) => {
    try {
      const filterPosts = posts.filter((p) => p.id !== data.postId);
      setPosts(filterPosts);

      let pinnedPosition = 1;
      if (existingPinnedPost.length > 0) {
        const maxPinnedPosition = _.maxBy(existingPinnedPost, 'position');
        pinnedPosition = maxPinnedPosition.position + 1;
      }
      const res = await apiService.addCategoryPinnedPost(categoryGroup, data.postId, pinnedPosition, PositionType.Rotatable);
      if (res) {
        toast.success('Successfully pinned');
        fetchApi(categoryGroup);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const onSearch = async () => {
    try {
      const mapExistingOfPinnedPostIds = existingPinnedPost.map((e) => e.postId);
      const postBrandKey = Trim(postBrandSearch, false, true);

      setLoading(true);
      const data = await apiService.getPostsByBrandAndCategoryGroup({ brand: postBrandKey, categoryGroup, pageSize, pageNo: pageNo - 1, orderCol: 'id', orderDir: 'DESC' });

      setAllPostCount(data.totalCount);
      setTotalCount(Math.ceil(data.totalCount / pageSize));

      const updatedData = _.map(data.rows, (d) => _.assign({
        ...d,
        isPinned: mapExistingOfPinnedPostIds.includes(d.id),
      }));
      setPosts(updatedData);

      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(err.message);
    }
  };

  useEffect(() => {
    if (openAdd) {
      onSearch();
    }
  }, [openAdd, postBrandSearch, pageNo]);

  return (
    <div className="row" style={{}}>
      { loading && <OverLoading />}
      <div className="col-md-12">
        <div className="content-header">
          <h1 className="d-flex align-items-center">
            <Link to="/admin/page" title="Back" className="d-flex align-items-center">
              <Icon className="back">arrow_back</Icon>
            </Link>
            Category Pinned Posts
          </h1>
        </div>
        <div className="row">
          <div className="col-md-2" style={{ backgroundColor: '#fff' }}>
            <MenuList>
              <Link color="secondary" to="/admin/categoryPinnedPost/All"><span><MenuItem style={{ color: categoryGroup === 'All' ? '#0027ff' : 'black' }}>All</MenuItem></span></Link>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography style={{ color: categoryGroup === 'Shop' ? '#0027ff' : 'black' }}>Shop</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Link style={{ width: '100%' }} to="/admin/categoryPinnedPost/Shop/All"><span><MenuItem style={{ color: categoryGroup === 'Shop' ? '#0027ff' : 'black' }}>All</MenuItem></span></Link>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography style={{ color: categoryGroup === 'Eat & Drink' ? '#0027ff' : 'black' }}>Eat & Drink</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Link style={{ width: '100%' }} to="/admin/categoryPinnedPost/Eat & Drink/All"><span><MenuItem style={{ color: categoryGroup === 'Eat & Drink' ? '#0027ff' : 'black' }}>All</MenuItem></span></Link>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography style={{ color: categoryGroup === 'Relax' ? '#0027ff' : 'black' }}>Relax</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Link style={{ width: '100%' }} to="/admin/categoryPinnedPost/Relax/All"><span><MenuItem style={{ color: categoryGroup === 'Relax' ? '#0027ff' : 'black' }}>All</MenuItem></span></Link>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography style={{ color: categoryGroup === 'Travel & Services' ? '#0027ff' : 'black' }}>Travel & Services</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Link style={{ width: '100%' }} to="/admin/categoryPinnedPost/Travel & Services/All"><span><MenuItem style={{ color: categoryGroup === 'Travel & Services' ? '#0027ff' : 'black' }}>All</MenuItem></span></Link>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography style={{ color: categoryGroup === 'Play' ? '#0027ff' : 'black' }}>Play</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Link style={{ width: '100%' }} to="/admin/categoryPinnedPost/Play/All"><span><MenuItem style={{ color: categoryGroup === 'Play' ? '#0027ff' : 'black' }}>All</MenuItem></span></Link>
                </AccordionDetails>
              </Accordion>
            </MenuList>
          </div>
          <div className="col-md-10 card-left">
            <div className="content-header" style={{ backgroundColor: '#fff' }}>
              <h1>
                {categoryGroup}
                {' '}
                Category Pinned Posts
              </h1>
              <Button onClick={onClickAdd} style={{ marginLeft: 'auto' }} color="primary" variant="contained" size="large">Add</Button>
            </div>
            <h5>*Click-and-hold item for 2sec to select and move it</h5>
            <SortableCard ref={SortableCardRef} onEvent={onSortableCardEvent} onDelete={(postId) => onDeletePinnedPost(postId)} onUpdatePosType={(data) => onUpdatePosType(data)} cards={existingPinnedPost} />
          </div>
        </div>
      </div>
      <Dialog fullWidth maxWidth="lg" open={openAdd} onClose={handleCloseAdd} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title" style={{ paddingTop: 20, paddingLeft: 50, paddingRight: 50 }}>
          <SearchBar
            onSearch={(postBrand) => {
              setPageNo(1);
              setPostBrandSearch(postBrand);
            }}
            existingPinnedPost={existingPinnedPost}
            label="Search by Post Brand"
            style={{ width: '100%' }}
          />
        </DialogTitle>
        <DialogContent style={{ height: '80vh', paddingLeft: 50, paddingRight: 50 }}>
          { !loading ? (
            <div className="container">
              <div className="row">
                <SearchCard data={posts} lastIndex={existingPinnedPost.length} onAdd={(data) => onAddPinnedPost(data)} />
              </div>
            </div>
          ) : <OverLoading /> }
        </DialogContent>
        <DialogActions style={{ paddingTop: 20, paddingRight: 20, paddingBottom: 10 }}>
          <div className="d-block" style={{ width: '100%' }}>
            <div className="float-left">
              {totalCount > 0 && (
                <Pagination
                  color="secondary"
                  size="large"
                  count={totalCount}
                  page={pageNo}
                  onChange={(event, value) => {
                    setPageNo(value);
                  }}
                  className="float-left"
                />
              )}
              <p style={{
                display:  'inline-block',
                margin:   '10px 0 0 30px',
                fontSize: 17,
              }}
              >
                Total count:
                {' '}
                {allPostCount}
              </p>
            </div>

            <Button onClick={handleCloseAdd} variant="contained" color="primary" className="float-right">Close</Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>

  );
};

CategoryPinnedPostList.propTypes = {
  match: PropTypes.shape({ params: PropTypes.shape({ categoryGroup: PropTypes.string, category: PropTypes.string }) }),
};

CategoryPinnedPostList.defaultProps = {
  match: {},
};

export default connect(null, null)(CategoryPinnedPostList);
